exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".draggable[data-v-ef35e58a]{position:fixed;cursor:move;user-select:none;z-index:9999}", ""]);

// exports
